module.exports = __webpack_public_path__ + "img/Container Loading Supervision_xuanzhong.2ada8b4f.png";